const route = {
	path: 'new',
	name: 'page-new-plan',
	meta: {
		title: 'Nuevo Plan',
	},
	props: true,
	component: () => import('@/pages/plans/page-plan-new'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/plans-new.js